import { DocumentService } from 'src/app/core/services/document.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Subscription } from 'rxjs';
import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { NotificationService } from 'src/app/core/services/notification.service';
import { Message } from 'src/app/core/class/message';

@Component({
  selector: 'app-sign-contract-notify',
  templateUrl: './sign-contract-notify.component.html',
  styleUrls: ['./sign-contract-notify.component.scss']
})
export class SignContractNotifyComponent implements OnInit {
  listUser = [];
  dataSelected = [];
  checkAll: boolean;
  sendEmail = true;
  // Number of checked documents
  public countCheck = 0;
  constructor(
    public dialogRef: MatDialogRef<SignContractNotifyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private documentService: DocumentService,
    public notificationService: NotificationService,
    private message: Message,

  ) {
    // them chuc nang close message băng Esc vaf click chuot
    dialogRef.disableClose = false;
    this.getDisplayedColumns();
  }

  columnDefinitions = [
    { def: 'check', showMobile: true },
    {def: 'userName', showXS: true, showSM: true, showMD: true},
    {def: 'isCreatedSide', showXS: true, showSM: true, showMD: true},
    {def: 'userRole', showXS: true, showSM: true, showMD: true},
    {def: 'isSendSms', showXS: true, showSM: true, showMD: true},
];
displayedColumns: string[] = [];
public mediaBreakpoint: any;
public subscribeMediaBreakPointService: Subscription;
public SCREEN_SIZE = SCREEN_SIZE;
  ngOnInit() {
    this.listUser =this.data.listUser;
  }

  onNoClick() {
    this.dialogRef.close();
  }

  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
        this.displayedColumns = this.columnDefinitions
            .filter(cd => cd.showXS)
            .map(cd => cd.def);
    } else {
        if (this.mediaBreakpoint === SCREEN_SIZE.MD) {
            this.displayedColumns = this.columnDefinitions
                .filter(cd => cd.showMD)
                .map(cd => cd.def);
        } else {
            this.displayedColumns = this.columnDefinitions.map(cd => cd.def);
        }

    }
}

  /**
   * check box change event.
   * @param item document item.
   * @param isChecked status of checkbox.
   */
   public onSelectionChange() {
    this.updateSignButtonsStatus();
  }

  public updateSignButtonsStatus() {
    if (this.listUser == null
      || this.listUser.length === 0) {
      return;
    }

    this.countCheck = 0;
    this.listUser.forEach(data => {
      data.updatedTime = null
      if (data.checked) {
        this.countCheck++;
      }

      const index = this.dataSelected.findIndex(item => item.id === data.id);
      if (index !== -1 && !data.checked) {
        this.dataSelected.splice(index, 1);
      } else if (index === -1 && data.checked) {
        this.dataSelected.push(data);
      }
    });

    // check all enable.
    if (this.countCheck === this.listUser.length) {
      this.checkAll = true;
    } else {
      this.checkAll = false;
    }
  }

     public checkAllDocument() {
      this.listUser.forEach(data => {
        data.checked = this.checkAll;
      });
      this.updateSignButtonsStatus();
    }

    sendNotify(): void {
      if (this.dataSelected.length > 0) {
        this.documentService.sendUserSignContract(this.data.data.id, this.dataSelected).subscribe(res => {
          if (res.success) {
            this.dialogRef.close(res.success);
          }
        });
      } else {
        this.notificationService.notify(this.message.getMessage('messages.error_not_sign_contract_user'));
      }
    }

}
